(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '@vivo/smooth-scrollbar'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('@vivo/smooth-scrollbar'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.smoothScrollbar);
    global.horizon = mod.exports;
  }
})(this, function (exports, _smoothScrollbar) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var HorizonPlugin = function (_ScrollbarPlugin) {
    _inherits(HorizonPlugin, _ScrollbarPlugin);

    function HorizonPlugin() {
      _classCallCheck(this, HorizonPlugin);

      return _possibleConstructorReturn(this, (HorizonPlugin.__proto__ || Object.getPrototypeOf(HorizonPlugin)).apply(this, arguments));
    }

    _createClass(HorizonPlugin, [{
      key: 'transformDelta',
      value: function transformDelta(delta) {
        if (Math.abs(delta.y) > Math.abs(delta.x)) {
          this.scrollbar.options['continuousScrolling'] = true;
          return { x: 0, y: 0 };
        }
        return {
          x: delta.x,
          y: delta.y
        };
      }
    }]);

    return HorizonPlugin;
  }(_smoothScrollbar.ScrollbarPlugin);

  HorizonPlugin.pluginName = 'horizon';
  exports.default = HorizonPlugin;
});